<template>
  <div>
    <h1>About Prime Fusion</h1>
    <p>Prime Fusion Oy is an innovative company based in Espoo, Finland.</p>
  </div>
</template>
